import Vue from 'vue'
import App from './App.vue'
import ElementUI, { Table } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import * as Sentry from '@sentry/vue'

// 初始化 Sentry
Sentry.init({
  Vue,
  dsn: 'https://fa4d0056113a41c8b7c63e2a93df53b4@glitchtip.kuaiman.com/2',
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.01,
  environment: 'prod',
  release: '1.0.0',
})

// 解决 ElTable 自动宽度高度导致的「ResizeObserver loop limit exceeded」问题
const fixElTableErr = (table) => {
  const oldResizeListener = table.methods.resizeListener;
  table.methods.resizeListener = function() {
    window.requestAnimationFrame(oldResizeListener.bind(this));
  };
};

// 一定要在Vue.use之前执行此函数
fixElTableErr(Table);

Vue.use(ElementUI)

new Vue({
  data: {
  },
  render: h => h(App)
}).$mount('#app')
